/*
 * Grid Messages
 *
 * This contains all the text for the Grid component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.grades.Grid';

export default defineMessages({
  allStudents: {
    id: `${scope}.allStudents`,
    defaultMessage: 'All students',
  },
  lowest: {
    id: `${scope}.lowest`,
    defaultMessage: 'Lowest',
  },
  mean: {
    id: `${scope}.mean`,
    defaultMessage: 'Mean',
  },
  median: {
    id: `${scope}.median`,
    defaultMessage: 'Median',
  },
  highest: {
    id: `${scope}.highest`,
    defaultMessage: 'Highest',
  },
});
